const SET_INSURANCE = 'setInsurance'
const SET_INSURANCES = 'setInsurances'

export const mutationTypes = {
  SET_INSURANCE,
  SET_INSURANCES
}

export const mutations = {
  [SET_INSURANCE] (state, payload) {
    state.insurance = payload
  },

  [SET_INSURANCES] (state, payload) {
    state.insurances = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/insurance/mutations.js